











































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import Reference from "@/interfaces/uniabc/Reference";
import { RefTypeEnum } from "@/interfaces/uniabc/RefTypeEnum";
import { readEntriesArray } from "@/store/uniabc/getters";
import { dispatchUpdateReference } from "@/store/uniabc/actions";
import EditorTooltip from "@/components/editor/editing/EditorTooltip.vue";
@Component({
  components: { EditorTooltip }
})
export default class EditReference extends Vue {
  @Prop(String) readonly label!: string;
  @Prop(String) readonly mode!: string;
  @PropSync("recomputeRefs", { type: Number }) updateRefs!: number;

  @Prop(Object)
  private refObj?: Reference;
  private reference: Reference = {
    key: "",
    reference: "",
    text: "",
    reftype: RefTypeEnum.NONE,
    quickaccess: ""
  };
  // private reftype!: RefTypeEnum
  private refIsActive = false;

  private dialog = false;

  @Watch("dialog")
  private onOpen(nowOpen: boolean) {
    if (nowOpen) {
      if (this.refObj) this.reference = this.refObj;
      else {
        this.reference = {
          key: "",
          reference: "",
          text: "",
          reftype: RefTypeEnum.NONE,
          quickaccess: ""
        };
      }
    }
  }

  get refTypes() {
    return Object.entries(RefTypeEnum).map(r => r[1]); //.map(r => RefTypeEnum[r as any])
  }

  private save() {
    dispatchUpdateReference(this.$store, {
      ref: this.reference!,
      label: this.label
    });
    this.updateRefs++;
    this.dialog = false;
  }

  // @Watch('reference', {deep: true, immediate: true})
  get referenceIsActive() {
    switch (this.reference!.reftype) {
      case RefTypeEnum.SUBENTRY:
      case RefTypeEnum.DZHREF:
      case RefTypeEnum.URL:
      case RefTypeEnum.LABEL:
      case RefTypeEnum.IMPORTANTURL:
        // this.refIsActive = true;
        // break
        return true;
      case RefTypeEnum.FOOTNOTE:
      case RefTypeEnum.LIST:
      case RefTypeEnum.NONE:
      case RefTypeEnum.INTERNAL:
      default:
        // this.refIsActive = false;
        // break
        return false;
    }

    // return false;
  }

  get textIsActive() {
    // this.reftype

    switch (this.reference!.reftype) {
      case RefTypeEnum.SUBENTRY:
      case RefTypeEnum.FOOTNOTE:
      case RefTypeEnum.LIST:
      case RefTypeEnum.LABEL:
      case RefTypeEnum.INTERNAL:
      case RefTypeEnum.DZHREF:
        return true;
      case RefTypeEnum.URL:
      case RefTypeEnum.IMPORTANTURL:
      case RefTypeEnum.NONE:
      default:
        return false;
    }

    // return false;
  }

  get quickaccessIsActive() {
    // this.reftype

    switch (this.reference!.reftype) {
      case RefTypeEnum.DZHREF:
        return true;
      case RefTypeEnum.SUBENTRY:
      case RefTypeEnum.FOOTNOTE:
      case RefTypeEnum.LIST:
      case RefTypeEnum.LABEL:
      case RefTypeEnum.INTERNAL:
      case RefTypeEnum.URL:
      case RefTypeEnum.IMPORTANTURL:
      case RefTypeEnum.NONE:
      default:
        return false;
    }

    // return false;
  }

  get isInternal() {
    return this.reference!.reftype === RefTypeEnum.INTERNAL;
  }

  get isNone() {
    return this.reference!.reftype === RefTypeEnum.NONE;
  }

  get entriesLabelList() {
    return readEntriesArray(this.$store)().map(e => e.label);
  }

  get ref() {
    return this.reference;
  }
}
